import apiClient from './client';

export const listDocuments = (params) => apiClient.get('/documents', { params }).then((r) => r.data);
export const uploadDocument = ({ file, clientId, projectId, category }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('clientId', clientId);
  if (projectId) formData.append('projectId', projectId);
  if (category) formData.append('category', category);
  return apiClient.post('/documents', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
};
export const downloadDocument = async (id, fileName) => {
  const response = await apiClient.get(`/documents/${id}/download`, { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName || `document-${id}`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
export const deleteDocument = (id) => apiClient.delete(`/documents/${id}`).then((r) => r.data);

// Document requests (employee asks client to upload a document)
export const listDocumentRequests = (params) => apiClient.get('/document-requests', { params }).then((r) => r.data);
export const createDocumentRequest = (payload) => apiClient.post('/document-requests', payload).then((r) => r.data);
export const fulfilDocumentRequest = (id, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return apiClient.post(`/document-requests/${id}/fulfil`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
};
export const reviewDocumentRequest = (id) => apiClient.patch(`/document-requests/${id}/review`).then((r) => r.data);